const NoteSection = () => {
    return (
        <div
            style={{
                background: '#e7f3fe',
                borderLeft: '6px solid #2196F3',
                padding: '3px 5px 5px 5px',
                marginTop: '10px',
            }}>
            <p style={{ marginBottom: '5px' }}>
                <strong>
                    By choosing the Text Message option, you have agreed to:
                </strong>
            </p>
            <ul style={{ listStyleType: 'disc', paddingLeft: '25px' }}>
                <li>Receive assistance via text messaging.</li>
                <li>Be aware that message and data rates may apply.</li>
                <li>
                    Receive text messages at the mobile number you provided
                    during the registration process.
                </li>
                <li>
                    For more information on privacy, visit: &nbsp;
                    <a
                        href="https://www.utsystem.edu/privacy"
                        target="_blank"
                        rel="noopener noreferrer">
                        https://www.utsystem.edu/privacy
                    </a>
                </li>
            </ul>
        </div>
    )
}
export default NoteSection
